// Models
import { IExerciseData } from 'storage/exercise/models'
import { IModelInput, IWorkoutSetInput } from 'models'

// React
import { FC, useCallback, useContext, useLayoutEffect, useMemo } from 'react'

// Libraries
import { ThemeContext } from 'styled-components'

// Misc
import { buttonClickTracking } from 'utils/tracking'
import { useMenu } from 'hooks'

// Components
import * as Styled from './styled'
import { Aligner, FormButton, List, SimpleContainer, Swipe } from 'heeds-ds'
import {
  ContentBox,
  HeaderWorkoutRoutine,
  SeriesFormTag,
  SpecialSeriesFormTag,
} from 'components'

type Props = {
  openExerciseGifModal: (exercise: IExerciseData) => void
  removeWorkoutSet: (setId: string) => void
  workoutData?: IModelInput[]
}

const Mobile: FC<Props> = ({
  openExerciseGifModal,
  removeWorkoutSet,
  workoutData,
}) => {
  const { setPagename } = useMenu()
  const theme = useContext(ThemeContext)

  const renderItem = useCallback(
    (stateSet: IWorkoutSetInput, prefix: string) => {
      return (
        <Aligner padding="0 0 16px">
          <Swipe
            active
            actions={[
              {
                icon: 'delete',
                onClick: () => removeWorkoutSet(stateSet.id),
                color: theme.colors.interactive.criticalDepressed,
              },
            ]}
            shadow
          >
            <Styled.Tag>
              {stateSet.type === 'normal' ? (
                <SeriesFormTag
                  displayMode
                  exercise={stateSet?.exercises[0]?.exercise}
                  name={`${prefix}.workout_set.${stateSet.id}`}
                  onClickImage={openExerciseGifModal}
                  visible
                />
              ) : (
                <SpecialSeriesFormTag
                  displayMode
                  onClickImage={openExerciseGifModal}
                  workoutSet={stateSet}
                  name={`${prefix}.workout_set.${stateSet.id}`}
                  visible
                />
              )}
            </Styled.Tag>
          </Swipe>
        </Aligner>
      )
    },
    [
      openExerciseGifModal,
      removeWorkoutSet,
      theme.colors.interactive.criticalDepressed,
    ],
  )

  const renderWorkoutData = useMemo(
    () =>
      workoutData?.map((workout, index) => (
        <ContentBox
          key={index}
          mobileCard
          collapsible
          title={workout.name.toUpperCase()}
          startsOpen={index === 0}
          padding="24px 0"
        >
          <List<IWorkoutSetInput>
            data={Object.values(workout.workout_set)}
            keyExtractor={(data) => data.id}
            renderItem={(data) => renderItem(data, `models.${index}`)}
          />
        </ContentBox>
      )),
    [renderItem, workoutData],
  )

  useLayoutEffect(() => {
    setPagename('Treinos')

    return () => setPagename('Dashboard')
  }, [setPagename])

  return (
    <SimpleContainer>
      <HeaderWorkoutRoutine />

      <Aligner flex="column" gap="24px" padding="24px">
        {renderWorkoutData}
      </Aligner>

      <Aligner justify="center" margin="46px 0 0 0">
        <FormButton
          track={buttonClickTracking}
          trackName="create_or_update_models"
        >
          Salvar
        </FormButton>
      </Aligner>
    </SimpleContainer>
  )
}

export default Mobile
